import { useId } from 'react'

export type SelectOption = { value: string; label: string } | string

interface Props {
  name?: string
  label?: string
  options?: SelectOption[]
  value?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  hint?: string
  error?: string
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

export function Select({
  name,
  label,
  options = [],
  value,
  placeholder,
  required = false,
  disabled = false,
  hint = '',
  error = '',
  onChange,
}: Props) {
  const id = useId()

  return (
    <div className={`cf-field${error ? ' cf-field--error' : ''}`}>
      {label && (
        <label className='cf-field__label' htmlFor={id}>
          {label}
          {required && (
            <span className='cf-field__required' aria-hidden>
              {' '}
              *
            </span>
          )}
        </label>
      )}
      <div className='cf-field__select-wrap'>
        <select
          className='cf-field__select'
          id={id}
          name={name}
          value={value}
          required={required}
          disabled={disabled}
          aria-describedby={hint || error ? `${id}-hint` : undefined}
          aria-invalid={error ? true : undefined}
          onChange={onChange}
        >
          {placeholder && (
            <option value='' disabled>
              {placeholder}
            </option>
          )}
          {options.map((opt) => {
            const v = typeof opt === 'string' ? opt : opt.value
            const l = typeof opt === 'string' ? opt : opt.label
            return (
              <option key={v} value={v}>
                {l}
              </option>
            )
          })}
        </select>
      </div>
      <span className='cf-field__hint' id={`${id}-hint`}>
        {error || hint}
      </span>
    </div>
  )
}
